export default __webpack_public_path__ + "static/media/two.7d2cb324.ogg";